import React from 'react';
import { Helmet } from 'react-helmet';
export const SEO = () => {
  const title = 'Aurum Grove Capital | Strategic Investment Management';
  const description = 'Aurum Grove Capital manages investments for a select group of family and friends in the Indian market, with a long-term approach focused on sustainable growth and wealth preservation.';
  const siteUrl = 'https://aurumgrove.capital'; // Replace with actual URL when deployed
  const ogImage = 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.1&auto=format&fit=crop&w=1200&h=630&q=80'; // Replace with actual image URL
  // JSON-LD structured data for investment company
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: 'Aurum Grove Capital',
    description: description,
    url: siteUrl,
    logo: ogImage,
    sameAs: [],
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN'
    },
    openingHours: 'Mo,Tu,We,Th,Fr 09:00-17:00',
    serviceType: ['Investment Management', 'Long-term Growth Strategies', 'Balanced Portfolios', 'Alternative Investments']
  };
  return <Helmet data-id="element-181">
      {/* Keep existing title and meta description */}
      <title data-id="element-182">{title}</title>
      <meta name="description" content={description} data-id="element-183" />
      {/* Meta robots tag for crawler visibility */}
      <meta name="robots" content="index, follow" data-id="element-184" />
      {/* Open Graph tags */}
      <meta property="og:type" content="website" data-id="element-185" />
      <meta property="og:url" content={siteUrl} data-id="element-186" />
      <meta property="og:title" content={title} data-id="element-187" />
      <meta property="og:description" content={description} data-id="element-188" />
      <meta property="og:image" content={ogImage} data-id="element-189" />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-190" />
      <meta name="twitter:title" content={title} data-id="element-191" />
      <meta name="twitter:description" content={description} data-id="element-192" />
      <meta name="twitter:image" content={ogImage} data-id="element-193" />
      {/* Structured data */}
      <script type="application/ld+json" data-id="element-194">
        {JSON.stringify(structuredData)}
      </script>
      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} data-id="element-195" />
    </Helmet>;
};